import React from "react";
import { Link } from "react-router-dom";
import { Puzzle, Truck, PackageSearch, ChevronRight } from "lucide-react";
import { BrandIcon } from "@/components/BrandIcon";
import { PageIcon } from "@/components/PageIcon";

const IDEAS = [
  { icon: Puzzle, title: "Add-ons & integrations", text: "Connect the tools you already use and switch on extra TedOps capabilities." },
  { icon: PackageSearch, title: "Products & suppliers", text: "Browse supplier catalogues and parts alongside your own products." },
  { icon: Truck, title: "Services & partners", text: "Find trusted installers, hauliers and service partners in one place." },
];

export default function Marketplace() {
  return (
    <div className="px-4 sm:px-8 pt-3 sm:pt-4 pb-6 sm:pb-8 max-w-4xl" data-testid="marketplace-page">
      <div className="flex items-center gap-3 mb-2">
        <PageIcon />
        <h1 className="text-2xl font-bold text-slate-900">Marketplace</h1>
        <span className="text-xs font-semibold uppercase tracking-wide rounded-full bg-amber-100 text-amber-800 px-2.5 py-1" data-testid="marketplace-coming-soon-badge">
          Coming soon</span>
      </div>
      <p className="text-sm sm:text-base text-slate-600 max-w-2xl mb-8" data-testid="marketplace-description">
        The TedOps Marketplace is on its way: a single place to discover add-ons, suppliers and partners that work with your TedOps account.
        Nothing here is live yet.
      </p>
      <Link to="/marketplace/ebay" data-testid="marketplace-ebay-card"
        className="mb-6 flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-5 hover:border-slate-300 hover:shadow-sm transition-shadow">
        <BrandIcon name="eBay" size={32} />
        <div><p className="text-sm font-semibold text-slate-900">eBay</p>
          <p className="text-xs text-slate-500">Connect seller accounts, import listings and match them to your products (read-only).</p></div>
        <ChevronRight className="w-4 h-4 text-slate-400 ml-auto" />
      </Link>
      <div className="grid gap-4 sm:grid-cols-3">
        {IDEAS.map(({ icon: Icon, title, text }) => (
          <div key={title} className="rounded-2xl border border-slate-200 bg-white p-5 opacity-90" data-testid={`marketplace-teaser-${title.split(" ")[0].toLowerCase()}`}>
            <Icon className="w-5 h-5 text-slate-400 mb-3" />
            <p className="text-sm font-semibold text-slate-800">{title}</p>
            <p className="text-xs text-slate-500 mt-1">{text}</p>
          </div>))}
      </div>
    </div>
  );
}
